module.exports = __webpack_public_path__ + "img/JOC_3199.c08d8f15.jpg";